import { Button, Card, Result, Spin } from 'antd';
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Title } from '../../components';
import {
  SiniestroProvider,
  useSiniestroContext
} from '../../context/siniestro-context';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import ConfirmarDatos from './ConfirmarDatos';

const SiniestroProv = () => (
  <SiniestroProvider>
    <SiniestroFormLanding />
  </SiniestroProvider>
);

export default SiniestroProv;

const SiniestroFormLanding = () => {
  const {
    loading,
    datosSiniestro,
    setDatosSiniestro,
    setLoading,
    setDatosAsegurado
  } = useSiniestroContext();
  const { token } = useParams();
  const history = useHistory();

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  useEffect(() => {
    const getSiniestroData = () => {
      setLoading(true);
      instanceRef.instance
        .get(`/siniestro/${token}`)
        .then((res) => {
          setDatosSiniestro(res.data.data);
          setDatosAsegurado(res.data.data.poliza);
          setLoading(false);
        })
        .catch((err) => {
          errorHandler(err, err.message);
        });
    };
    getSiniestroData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {datosSiniestro &&
        datosSiniestro.estado === 'DENUNCIA' &&
        datosSiniestro.etapa === 'PENDIENTE' && (
          <Card style={{ margin: '20px' }}>
            {' '}
            <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
              {datosSiniestro && (
                <>
                  <Title stlye={{ marginBottom: '10px' }}>
                    Denuncia de Siniestro
                  </Title>
                  <ConfirmarDatos title="Detalle de datos" contacto={false} />
                  <div style={{ marginTop: '10px' }}>
                    <Button
                      type="primary"
                      onClick={() =>
                        handleOpenUrl(`/denuncia-siniestro/${token}`)
                      }
                    >
                      Iniciar
                    </Button>
                  </div>
                </>
              )}
            </Spin>
          </Card>
        )}
      {datosSiniestro &&
        (datosSiniestro.etapa === 'PENDIENTE_FIRMA' ||
          datosSiniestro.etapa === 'FIRMADA') && (
          <Card style={{ margin: '20px' }}>
            <Result
              status="success"
              title="¡El Siniestro ya está en proceso de firma!"
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => {
                    window.location.href = `/`;
                  }}
                >
                  Ir al inicio
                </Button>
              ]}
            />
          </Card>
        )}
    </>
  );
};
